const OAUTH_RESPONSE_PARAMS = ['code', 'session_state', 'iss'];
const KC_ACTION_PARAMS = ['kc_action', 'kc_action_status'];
const KC_ACTION_STATUS_KEY = 'kcActionStatus';

/**
 * Magic links land on the redirect URI with ``?code=&session_state=&iss=`` but no ``state``,
 * because the backend, not keycloak-js, started the flow. keycloak-js only consumes callbacks
 * carrying a ``state`` it issued, so it ignores these params and runs check-sso with the
 * current URL as the redirect_uri. Keycloak 26.7+ rejects a redirect_uri containing OAuth
 * response params ("Invalid parameter: redirect_uri"), so they must go before init.
 *
 * The magic link has already established the Keycloak SSO session; check-sso then issues a
 * fresh code through a clean redirect.
 *
 * Change Password (``kc_action=UPDATE_PASSWORD``) returns the same way, plus
 * ``kc_action=UPDATE_PASSWORD&kc_action_status=success|cancelled``. Keycloak 26.7+ rejects both
 * in a redirect_uri too, so they go as well. The status is handed to the settings modal's
 * success toast through sessionStorage; see ``takeKcActionStatus``.
 *
 * Returns the cleaned path + search + hash, or null when there is nothing to strip.
 */
export function stripStaleOAuthParams(href: string): string | null {
  const url = new URL(href);
  let stripped = false;
  if (url.searchParams.has('code') && !url.searchParams.has('state')) {
    OAUTH_RESPONSE_PARAMS.forEach((param) => url.searchParams.delete(param));
    stripped = true;
  }
  if (KC_ACTION_PARAMS.some((param) => url.searchParams.has(param))) {
    const status = url.searchParams.get('kc_action_status');
    if (status) {
      sessionStorage.setItem(KC_ACTION_STATUS_KEY, status);
    }
    KC_ACTION_PARAMS.forEach((param) => url.searchParams.delete(param));
    stripped = true;
  }
  return stripped ? url.pathname + url.search + url.hash : null;
}

/** Returns the ``kc_action_status`` saved by ``stripStaleOAuthParams`` once, then clears it. */
export function takeKcActionStatus(): string | null {
  const status = sessionStorage.getItem(KC_ACTION_STATUS_KEY);
  sessionStorage.removeItem(KC_ACTION_STATUS_KEY);
  return status;
}
